import { useEffect } from 'react'
import { APP_VERSION } from '../version'

const CHECK_INTERVAL_MS = 5 * 60 * 1000

export const useVersionCheck = () => {
    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch(`/version.json?ts=${Date.now()}`, { cache: 'no-store' })
                const data = await response.json()
                const latestVersion = data?.version

                if (latestVersion && latestVersion !== APP_VERSION) {
                    const reloadKey = `app-version-reloaded-${latestVersion}`
                    if (!sessionStorage.getItem(reloadKey)) {
                        sessionStorage.setItem(reloadKey, '1')
                        window.location.reload()
                    }
                }
            } catch (err) {
                // Offline or a transient network hiccup - just retry on the next interval
            }
        }

        checkVersion()

        const interval = setInterval(checkVersion, CHECK_INTERVAL_MS)

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                checkVersion()
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            clearInterval(interval)
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [])
}
